/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from '@vlinder-web/plugin-agent-service-react';
import {
  BlockchainTransactionPlugin,
  IBlockchainTransactionPluginMethods,
  FeatureActualDetailPlugin,
  IFeatureActualDetailPluginMethods,
  FooterActualDetailDetailPlugin,
  IFooterActualDetailDetailPluginMethods,
  FormatPolicyPlugin,
  IFormatPolicyPluginMethods,
  FormatTimelinePlugin,
  TransactionListPlugin,
  ITransactionListPluginMethods,
  HeaderActualDetailPlugin,
  IHeaderActualDetailPluginMethods,
  StaticActualDetailPlugin,
  IStaticActualDetailPluginMethods,
  LoadingActualDetailPlugin,
  ILoadingActualDetailPluginMethods,
  ErrorActualDetailPlugin,
  IErrorActualDetailPluginMethods,
  IFormatTimelinePluginMethods,
} from './plugins';
import { errorActualDetailConfig } from '../config/error.config';
import { loadingActualDetailConfig } from '../config/loading.config';

export type TAgent = IBlockchainTransactionPluginMethods &
  IFeatureActualDetailPluginMethods &
  IFooterActualDetailDetailPluginMethods &
  IFormatPolicyPluginMethods &
  IFeatureActualDetailPluginMethods &
  ITransactionListPluginMethods &
  IHeaderActualDetailPluginMethods &
  IStaticActualDetailPluginMethods &
  ILoadingActualDetailPluginMethods &
  IErrorActualDetailPluginMethods &
  IFormatTimelinePluginMethods;

const getPlugins = () => {
  return [
    new StaticActualDetailPlugin(),
    new ErrorActualDetailPlugin(),
    new LoadingActualDetailPlugin(),
    //Business logic plugins !
    new BlockchainTransactionPlugin(),
    new FeatureActualDetailPlugin(),
    new FooterActualDetailDetailPlugin(),
    new FormatPolicyPlugin(),
    new FormatTimelinePlugin(),
    new HeaderActualDetailPlugin(),
    new TransactionListPlugin(),
  ];
};

export const getAgent = () => {
  return createAgent<TAgent>({
    plugins: getPlugins(),
  });
};
